export const getClientTimeInISO = (): string => {
	const now = new Date();
	const offset = -now.getTimezoneOffset(); // Timezone offset in minutes
	const adjustedDate = new Date(now.getTime() + offset * 60 * 1000); // Adjust to local timezone
	return adjustedDate.toISOString().slice(0, 19); // Remove milliseconds and 'Z'
};
